import { Checkbox } from "@/components/ui/checkbox";
import { useTranslation } from "react-i18next";

interface TermsOfSaleCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
  /** Unique id when more than one checkbox is on the page. */
  id?: string;
}

export function TermsOfSaleCheckbox({
  checked,
  onCheckedChange,
  className,
  id = "terms-of-sale",
}: TermsOfSaleCheckboxProps) {
  const { t } = useTranslation();

  return (
    <label
      htmlFor={id}
      className={`flex items-start gap-2.5 cursor-pointer select-none ${className ?? ""}`}
    >
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(v) => onCheckedChange(v === true)}
        className="mt-0.5"
      />
      <span className="text-sm text-muted-foreground">
        {t("checkout.agreeToTerms")}{" "}
        <a
          href="/terms-of-sale"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary underline hover:text-primary/80"
          onClick={(e) => e.stopPropagation()}
        >
          {t("checkout.termsOfSaleLink")}
        </a>{" "}
        {t("checkout.and")}{" "}
        <a
          href="/returns"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary underline hover:text-primary/80"
          onClick={(e) => e.stopPropagation()}
        >
          {t("checkout.returnsRefundsLink")}
        </a>
      </span>
    </label>
  );
}
